import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercardLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 24,
	viewBox: "0 0 34 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 33,
			height: 23,
			rx: 3.5,
			fill: "white",
			stroke: "#D6D8DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.179 16.8297C15.9949 17.8278 14.459 18.4303 12.7807 18.4303C9.03582 18.4303 6 15.4306 6 11.7303C6 8.02997 9.03582 5.03027 12.7807 5.03027C14.459 5.03027 15.9949 5.63277 17.179 6.63081C18.363 5.63277 19.8989 5.03027 21.5773 5.03027C25.3221 5.03027 28.358 8.02997 28.358 11.7303C28.358 15.4306 25.3221 18.4303 21.5773 18.4303C19.8989 18.4303 18.363 17.8278 17.179 16.8297Z",
			fill: "#ED0006"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.1787 16.8297C18.6366 15.6008 19.5611 13.7722 19.5611 11.7303C19.5611 9.68832 18.6366 7.85972 17.1787 6.63081C18.3628 5.63277 19.8987 5.03027 21.577 5.03027C25.3219 5.03027 28.3577 8.02997 28.3577 11.7303C28.3577 15.4306 25.3219 18.4303 21.577 18.4303C19.8987 18.4303 18.3628 17.8278 17.1787 16.8297Z",
			fill: "#F9A000"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.1793 16.8297C18.6372 15.6008 19.5616 13.7722 19.5616 11.7303C19.5616 9.68835 18.6372 7.85976 17.1793 6.63086C15.7213 7.85976 14.7969 9.68835 14.7969 11.7303C14.7969 13.7722 15.7213 15.6008 17.1793 16.8297Z",
			fill: "#FF5E00"
		})
	]
});
export default SvgMastercardLogo;
